import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e385398e&scoped=true&lang=html"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e385398e",
  null
  
)

export default component.exports